import Echo from 'laravel-echo';
import store from '@/store';

const Socket = {
    installEcho(Vue) {
        /* Lu à l'installation, pas à l'import du module : arrivé depuis `app` par ?access_token=,
         * le jeton n'est posé par le routeur qu'après le chargement du module, sans rechargement.
         * Lu à l'import, il manquait : pas de $echo, et la fiche ticket plantait (« Ticket #null »). */
        const authToken = Vue.ls.get('Authorization');
        if (!authToken) return false;
        window.io = require('socket.io-client');
        Vue.prototype.$echo = new Echo({
            broadcaster: 'socket.io',
            host: process.env.VUE_APP_API_SOCKET_URL,
            auth: {headers: {Authorization: `Bearer ${authToken}`}}
        });

        Vue.prototype.$echo.connector.socket.on('connect', function () {
            store.commit('echo/SET_IS_CONNECTED', true);
        });
        Vue.prototype.$echo.connector.socket.on('disconnect', function () {
            store.commit('echo/SET_IS_CONNECTED', false);
        });
    }
};

export default Socket;
